import React, { useState, useEffect } from 'react';
import { FaUtensils, FaShoppingBag, FaCheckCircle, FaTruck, FaClock, FaListAlt, FaSync, FaHistory } from 'react-icons/fa';
import Layout from '../components/Layout';

const StatusPedido = () => {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const isMobile = window.innerWidth < 768;

  // Simulação de dados de múltiplos pedidos
  useEffect(() => {
    setTimeout(() => {
      setPedidos([
        {
          id: '12345',
          numero: 'PED-2023-001',
          status: 'preparando',
          itens: [
            { nome: 'X-Burger', quantidade: 1, preco: 15.90 },
            { nome: 'Batata Frita Média', quantidade: 1, preco: 8.50 },
            { nome: 'Refrigerante 500ml', quantidade: 1, preco: 6.00 }
          ],
          total: 30.40,
          dataHora: new Date(Date.now() - 15 * 60000).toISOString(), // 15 minutos atrás
          tempoEstimado: 25,
          tempoDecorrido: 15
        },
        {
          id: '12346',
          numero: 'PED-2023-002',
          status: 'pronto',
          itens: [
            { nome: 'Pizza Média', quantidade: 1, preco: 32.00 },
            { nome: 'Coca-Cola 2L', quantidade: 1, preco: 10.00 }
          ],
          total: 42.00,
          dataHora: new Date(Date.now() - 45 * 60000).toISOString(), // 45 minutos atrás
          tempoEstimado: 35,
          tempoDecorrido: 45
        },
        {
          id: '12347',
          numero: 'PED-2023-003',
          status: 'entregue',
          itens: [
            { nome: 'Hot Dog', quantidade: 2, preco: 8.00 },
            { nome: 'Suco Natural', quantidade: 1, preco: 7.00 }
          ],
          total: 23.00,
          dataHora: new Date(Date.now() - 120 * 60000).toISOString(), // 2 horas atrás
          tempoEstimado: 20,
          tempoDecorrido: 20
        }
      ]);
      setPedidoSelecionado('12345');
      setLoading(false);
    }, 1000);

    // Timer para atualizar tempo decorrido
    const timer = setInterval(() => {
      setPedidos(prev => prev.map(pedido => ({
        ...pedido,
        tempoDecorrido: pedido.status !== 'entregue' ? pedido.tempoDecorrido + 1 : pedido.tempoDecorrido
      })));
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  // Definir etapas do pedido
  const etapas = [
    { id: 'recebido', nome: 'Recebido', icon: <FaCheckCircle /> },
    { id: 'preparando', nome: 'Preparando', icon: <FaUtensils /> },
    { id: 'pronto', nome: 'Pronto', icon: <FaShoppingBag /> },
    { id: 'entregue', nome: 'Entregue', icon: <FaTruck /> }
  ];

  // Função para obter pedido selecionado
  const getPedidoSelecionado = () => {
    return pedidos.find(pedido => pedido.id === pedidoSelecionado);
  };

  // Função para simular atualização de status
  const atualizarStatus = (pedidoId) => {
    setPedidos(prev => prev.map(pedido => {
      if (pedido.id === pedidoId) {
        const statusAtual = pedido.status;
        let novoStatus = statusAtual;
        
        if (statusAtual === 'recebido') novoStatus = 'preparando';
        else if (statusAtual === 'preparando') novoStatus = 'pronto';
        else if (statusAtual === 'pronto') novoStatus = 'entregue';
        
        return { ...pedido, status: novoStatus };
      }
      return pedido;
    }));
  };

  // Função para obter pedidos em andamento
  const getPedidosAndamento = () => {
    return pedidos.filter(pedido => pedido.status !== 'entregue');
  };

  // Função para obter pedidos finalizados
  const getPedidosFinalizados = () => {
    return pedidos.filter(pedido => pedido.status === 'entregue');
  };

  // Função para calcular progresso
  const calcularProgresso = (pedido) => {
    const etapaAtualIndex = etapas.findIndex(etapa => etapa.id === pedido.status);
    return etapaAtualIndex >= 0 ? (etapaAtualIndex / (etapas.length - 1)) * 100 : 0;
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <Layout title="Pedido" icon={FaListAlt}>
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner}></div>
            <p>Carregando seus pedidos...</p>
          </div>
        </Layout>
      </div>
    );
  }

  const pedidoAtual = getPedidoSelecionado();
  const pedidosAndamento = getPedidosAndamento();
  const pedidosFinalizados = getPedidosFinalizados();

  return (
    <div style={styles.container}>
      <Layout title="Pedido" icon={FaListAlt}>
        <div style={isMobile ? styles.mobileContainer : styles.desktopContainer}>
          
          {/* Pedidos em Andamento */}
          {pedidosAndamento.length > 0 && (
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Pedidos em Andamento</h3>
              <div style={styles.pedidosGrid}>
                {pedidosAndamento.map(pedido => (
                  <div 
                    key={pedido.id} 
                    style={{
                      ...styles.pedidoCard,
                      ...(pedidoSelecionado === pedido.id ? styles.pedidoCardSelecionado : {})
                    }}
                    onClick={() => setPedidoSelecionado(pedido.id)}
                  >
                    {/* Header do Card */}
                    <div style={styles.pedidoHeader}>
                      <div style={styles.pedidoInfo}>
                        <h4 style={styles.pedidoNumero}>#{pedido.numero}</h4>
                        <span style={styles.pedidoStatus}>{pedido.status}</span>
                      </div>
                      <div style={styles.pedidoTempo}>
                        <FaClock style={styles.tempoIcon} />
                        <span>{pedido.tempoDecorrido} min</span>
                      </div>
                    </div>

                    {/* Barra de Progresso */}
                    <div style={styles.statusProgresso}>
                      <div 
                        style={{
                          ...styles.statusBarra,
                          width: `${calcularProgresso(pedido)}%`
                        }}
                      ></div>
                    </div>

                    {/* Etapas */}
                    <div style={styles.statusEtapas}>
                      {etapas.map((etapa, index) => {
                        const ativa = index <= etapas.findIndex(e => e.id === pedido.status);
                        return (
                          <div key={etapa.id} style={styles.statusEtapa}>
                            <div 
                              style={{
                                ...styles.etapaIcon,
                                ...(ativa ? styles.etapaIconAtiva : styles.etapaIconInativa)
                              }}
                            >
                              {etapa.icon}
                            </div>
                            <div 
                              style={{
                                ...styles.etapaTexto,
                                ...(ativa ? styles.etapaTextoAtiva : styles.etapaTextoInativa)
                              }}
                            >
                              {etapa.nome}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* Detalhes Compactos */}
                    <div style={styles.detalhesCompactos}>
                      <div style={styles.itensResumo}>
                        {pedido.itens.slice(0, 2).map((item, index) => (
                          <span key={index} style={styles.itemResumo}>
                            {item.quantidade}x {item.nome}
                          </span>
                        ))}
                        {pedido.itens.length > 2 && (
                          <span style={styles.maisItens}>+{pedido.itens.length - 2} itens</span>
                        )}
                      </div>
                      <div style={styles.totalCompacto}>
                        R$ {pedido.total.toFixed(2)}
                      </div>
                    </div>

                    {/* Botão de Atualizar */}
                    <div style={styles.acoesContainer}>
                      <button 
                        style={{
                          ...styles.atualizarButton,
                          ...(pedido.status === 'entregue' ? styles.buttonDisabled : {})
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          atualizarStatus(pedido.id);
                        }}
                        disabled={pedido.status === 'entregue'}
                      >
                        <FaSync style={styles.buttonIcon} />
                        Atualizar Status
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Pedidos Finalizados */}
          {pedidosFinalizados.length > 0 && (
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                <FaHistory style={styles.sectionIcon} />
                Pedidos Finalizados
              </h3>
              <div style={styles.pedidosGrid}>
                {pedidosFinalizados.map(pedido => (
                  <div 
                    key={pedido.id} 
                    style={styles.pedidoCardFinalizado}
                    onClick={() => setPedidoSelecionado(pedido.id)}
                  >
                    <div style={styles.pedidoHeader}>
                      <div style={styles.pedidoInfo}>
                        <h4 style={styles.pedidoNumero}>#{pedido.numero}</h4>
                        <span style={styles.pedidoStatusFinalizado}>Entregue</span>
                      </div>
                      <div style={styles.pedidoData}>
                        {new Date(pedido.dataHora).toLocaleDateString('pt-BR')}
                      </div>
                    </div>
                    
                    <div style={styles.detalhesCompactos}>
                      <div style={styles.itensResumo}>
                        {pedido.itens.slice(0, 2).map((item, index) => (
                          <span key={index} style={styles.itemResumo}>
                            {item.quantidade}x {item.nome}
                          </span>
                        ))}
                      </div>
                      <div style={styles.totalCompacto}>
                        R$ {pedido.total.toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>
      </Layout>
      
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

// Estilos
const styles = {
  container: {
    margin: '0 auto',
    fontFamily: '"Montserrat", sans-serif',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
  },
  
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
    gap: '20px',
  },
  
  desktopContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    gap: '20px',
    marginTop: '20px'
  },

  section: {
    marginBottom: '30px',
  },

  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#09448C',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  sectionIcon: {
    fontSize: '16px',
  },

  pedidosGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },

  pedidoCard: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  pedidoCardSelecionado: {
    borderColor: '#09448C',
    boxShadow: '0 4px 15px rgba(9, 68, 140, 0.2)',
  },

  pedidoCardFinalizado: {
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    padding: '20px',
    border: '1px solid #e9ecef',
    cursor: 'pointer',
    opacity: 0.8,
  },

  pedidoHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '15px',
  },

  pedidoInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },

  pedidoNumero: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#09448C',
    margin: 0,
  },

  pedidoStatus: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#28a745',
    textTransform: 'capitalize',
  },

  pedidoStatusFinalizado: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#6c757d',
  },

  pedidoTempo: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: '12px',
    color: '#6c757d',
  },

  tempoIcon: {
    fontSize: '12px',
  },

  pedidoData: {
    fontSize: '12px',
    color: '#6c757d',
  },

  statusProgresso: {
    width: '100%',
    height: '6px',
    backgroundColor: '#e9ecef',
    borderRadius: '3px',
    overflow: 'hidden',
    marginBottom: '15px',
  },

  statusBarra: {
    height: '100%',
    backgroundColor: '#09448C',
    borderRadius: '3px',
    transition: 'width 0.5s ease',
  },

  statusEtapas: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '15px',
  },

  statusEtapa: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },

  etapaIcon: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '5px',
    fontSize: '14px',
  },

  etapaIconAtiva: {
    backgroundColor: '#09448C',
    color: '#fff',
  },

  etapaIconInativa: {
    backgroundColor: '#e9ecef',
    color: '#6c757d',
  },

  etapaTexto: {
    fontSize: '10px',
    textAlign: 'center',
    fontWeight: '500',
  },

  etapaTextoAtiva: {
    color: '#09448C',
  },

  etapaTextoInativa: {
    color: '#6c757d',
  },

  detalhesCompactos: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
  },

  itensResumo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    flex: 1,
  },

  itemResumo: {
    fontSize: '12px',
    color: '#495057',
  },

  maisItens: {
    fontSize: '11px',
    color: '#6c757d',
    fontStyle: 'italic',
  },

  totalCompacto: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#09448C',
  },

  acoesContainer: {
    display: 'flex',
    justifyContent: 'center',
  },

  atualizarButton: {
    backgroundColor: '#09448C',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 16px',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },

  buttonDisabled: {
    backgroundColor: '#6c757d',
    cursor: 'not-allowed',
  },

  buttonIcon: {
    fontSize: '12px',
  },

  infoContainer: {
    backgroundColor: '#f1f8ff',
    borderRadius: '10px',
    padding: '20px',
    borderLeft: '4px solid #09448C',
  },

  infoTitle: {
    color: '#09448C',
    marginTop: '0',
    marginBottom: '15px',
    fontSize: '16px',
  },

  infoList: {
    paddingLeft: '20px',
    margin: '0',
  },

  infoItem: {
    marginBottom: '8px',
    color: '#495057',
    fontSize: '14px',
    lineHeight: '1.5',
  },

  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },

  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #e9ecef',
    borderTop: '4px solid #09448C',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '20px',
  },
};

export default StatusPedido;